import 'css-chunksrc/client/pages/zonesPage/zonesPage/styles.scss';export default {
  "projectsPage": "_projectsPage_wdk22_1",
  "content": "_content_wdk22_10",
  "main": "_main_wdk22_17",
  "header": "_header_wdk22_25",
  "addZoneButton": "_addZoneButton_wdk22_33",
  "wrapper": "_wrapper_wdk22_37",
  "zones": "_zones_wdk22_46",
  "list": "_list_wdk22_52",
  "item": "_item_wdk22_60"
};